module.exports = __webpack_public_path__ + "static/media/apple-maps.7c502b06.png";